import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import Isotope from 'isotope-layout';

/**
 * Display a card view.
 */
export default class Cards {
	constructor() {
		this.isotope = null;
	}

	/**
	 * Setup cards
	 *
	 * cards -> a jQuery object that contains all cards (usually an ul element)
	 * card -> a jQuery object that contains a single card (usually a li element)
	 * layout -> layout mode - masonry or fitRows
	 * isStill -> boolean - choose between animated or still layout
	 */
	setup(cards, card, layout, isStill) {
		const transition = isStill ? 0 : '0.1s';

		const options = {
			itemSelector: card,
			transitionDuration: transition,
			getSortData: {
				'sort-order': '.sort-order parseInt',
			},
			sortBy: 'sort-order',
			sortAscending: true,
			isOriginLeft: !$('html[dir=rtl]').length,
		};

		if (layout === 'fitRows') {
			options.layoutMode = 'fitRows';
		} else {
			options.masonry = {
				columnWidth: 240,
				gutter: 20,
				horizontalOrder: true,
			};
		}

		if ($(cards).length > 0) {
			imagesLoaded(cards, () => {
				this.isotope = new Isotope(cards, options);

				$('body').on('tabchange', () => {
					this.isotope.layout();
				});
			});
		}
	}

	refresh() {
		if (!this.isotope) return;

		this.isotope.reloadItems();
		this.isotope.arrange();
	}
}
